import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

interface IAutoResponderFormProps {
    note: string;
    from: Date;
    to: Date;
}

class AutoResponderFormState {
    public constructor(state?: AutoResponderFormState) {
        if (state == null) {
            this.note = "";
            this.from = null;
            this.to = null;
        }
        else {
            this.note = state.note;
            this.from = state.from;
            this.to = state.to;
        }
    }

    public note: string;
    public from: Date;
    public to: Date;
}

class AutoResponderForm extends React.Component<IAutoResponderFormProps, AutoResponderFormState> {
    public constructor(props: IAutoResponderFormProps) {
        super(props);

        const initialState = new AutoResponderFormState();
        initialState.from = this.props.from;
        initialState.to = this.props.to;
        initialState.note = this.props.note;

        this.state = initialState;
    }

    // todo: build autoresponders form

    public render(): JSX.Element {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">

                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <label>{cacheStore.GetString("DuLabel")}</label>
                            <DateSelector valid={this.isDateValid()} id="autor_from" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={this.state.from} onSelectOp={LocalOperations.Unassigned.Unassigned} onChangeCallback={this.onFromChange.bind(this)} />
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <label>{cacheStore.GetString("AuLabel")}</label>
                            <DateSelector valid={this.isDateValid()} id="autor_to" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={this.state.to} onSelectOp={LocalOperations.Unassigned.Unassigned} onChangeCallback={this.onToChange.bind(this)} />
                        </div>
                    </div>

                    <div className="row native">
                        <div className="col-md-12 col-lg-6">
                            <label>Note</label>
                            <textarea className="form-control" onChange={this.onNoteChange.bind(this)} value={this.state.note} rows={4} />
                            <div style={{ marginTop: "5px" }} className="right">
                                <ButtonControl label={cacheStore.GetString("CancelLabel")} className="btn btn-default push-right-5" onClick={e => this.CancelForm(e)} />
                                <ButtonControl disabled={!this.isDateValid()} label={cacheStore.GetString("SaveLabel")} className="btn btn-primary push-right-5" onClick={e => this.SaveAutoResponders(e)} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    public shouldComponentUpdate(): boolean {
        return true;
    }

    private onFromChange(value: Date): void {
        var s = new AutoResponderFormState(this.state);
        s.from = value;
        this.setState(s);
    }
    private onToChange(value: Date): void {
        var s = new AutoResponderFormState(this.state);
        s.to = value;
        this.setState(s);
    }

    private onNoteChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        var s = new AutoResponderFormState(this.state);
        s.note = e.target.value;
        this.setState(s);
    }

    private CancelForm(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalOperations.SettingsUI.AutoRespondersControlShowHide);
        operation.AddItem("value", new KeyValuePair("", "f"));
        LocalEventDispatcher.dispatch(operation);
    }

    private SaveAutoResponders(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalOperations.Settings.SaveAutoResponder);
        operation.AddItem("from", this.state.from);
        operation.AddItem("to", this.state.to);
        operation.AddItem("note", this.state.note);
        LocalEventDispatcher.dispatch(operation);
    }

    private isDateValid(): boolean {
        const from = LuxonDateTimeParser.parse(this.state.from);
        const to = LuxonDateTimeParser.parse(this.state.to);
        return from?.isValid && (from <= to || to === null);
    }
}

export { AutoResponderForm };
